import cn from 'classnames'
import { Field as FormikField } from 'formik'
import { FC } from 'react'

import FieldError from 'components/Form/FieldError/FieldError'

import styles from './Field.module.scss'

interface IProps {
  name: string
  type?: string
  className?: string
  id?: string
  withHorizontalTooltip?: boolean
  [key: string]: any
}

const Field: FC<IProps> = ({ name, type, className, withHorizontalTooltip = true, ...props }) => {
  return (
    <div className={cn(styles.field, className, { [styles.inline]: type === 'checkbox' })}>
      <FormikField name={name} type={type} {...props} />
      <FieldError name={name} withHorizontalTooltip={withHorizontalTooltip} />
    </div>
  )
}

export default Field
